export const approveRequest = [
    {
        submittedBy: "JamesDeckar(9004)",
        leaveType: "Medical Leave",
        role: "Student",
        leaveDate: "05 May 2024-07 may 2024",
        noofDays: 5,
        appliedOn: "05May2024",
        authority: "Jacquelin",
        status: "Approved"
    },
    {
        submittedBy: "Richard(2145)",
        leaveType: "Casual Leave",
        role: "Teacher",
        leaveDate: "07 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "07May2024",
        authority: "Elizabeth",
        status: "Approved"
    },
    {
        submittedBy: "Susan(4147)",
        leaveType: "Maternity Leave",
        role: "Admin",
        leaveDate: "08 May 2024-19 may2024",
        noofDays: 10,
        appliedOn: "02May2024",
        authority: "Teresa",
        status: "Approved"
    },
    {
        submittedBy: "Lisa(2145)",
        leaveType: "Sick Leave",
        role: "Librarian",
        leaveDate: "05 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "04May2024",
        authority: "Edward",
        status: "Approved"
    },
    {
        submittedBy: "Janet(1457)",
        leaveType: "Paternity Leave",
        role: "Driver",
        leaveDate: "07 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "06May2024",
        authority: "Daniel",
        status: "Disapproved"
    },
    {
        submittedBy: "Ryan(9784)",
        leaveType: "Special Leave",
        role: "Student",
        leaveDate: "08 May 2024-19 may 2024",
        noofDays: 1,
        appliedOn: "12May2024",
        authority: "Hellana",
        status: "Pending"
    },
    {
        submittedBy: "Gifford(7457)",
        leaveType: "Medical Leave",
        role: "Student",
        leaveDate: "07 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "04May2024",
        authority: "Erickson",
        status: "Pending"
    },
    {
        submittedBy: "Julie(4655)",
        leaveType: "Casual Leave",
        role: "Student",
        leaveDate: "05 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "04May2024",
        authority: "Raul",
        status: "Approved"
    },
    {
        submittedBy: "Joann(4178)",
        leaveType: "Medical Leave",
        role: "Student",
        leaveDate: "08 May 2024-19 may 2024",
        noofDays: 1,
        appliedOn: "04May2024",
        authority: "Aaron",
        status: "Pending"
    },
    {
        submittedBy: "Kathleen(5898)",
        leaveType: "Casual Leave",
        role: "Student",
        leaveDate: "07 May 2024-07 may 2024",
        noofDays: 1,
        appliedOn: "04May2024",
        authority: "Morgan",
        status: "Pending"
    }
];
